export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("auto-title", {
    mounted(el: HTMLElement) {
      if (el.tagName.toLowerCase() === "img" && el.hasAttribute("alt")) {
        el.title = el.getAttribute("alt") || "";
      }
    },
    updated(el: HTMLElement) {
      if (el.tagName.toLowerCase() === "img" && el.hasAttribute("alt")) {
        el.title = el.getAttribute("alt") || "";
      }
    },
  });
});
